<template>
    <div id="app" class="app wrapper">
        <header>
            <div id="nav" class="nav">
                <div class="aix-menu">
                    <nav class="navbar navbar-expand-lg navbar-light">
                        <i class="fas fa-bars navbar-toggler"></i>
                        <div class="collapse navbar-collapse" id="navbarNavAltMarkup">
                            <div class="navbar-nav">
                                <a class="nav-item nav-link" href="javascript:void(0)">
                                    <router-link to="/" class="r-link"><i class="fas fa-crosshairs" title="Home"></i>Home</router-link>
                                </a>
                                <a class="nav-item nav-link" href="javascript:void(0)">
                                    <router-link to="/curriculum" class="r-link"><i class="fas fa-user" title="Curriculum Vitae"></i>Curriculum Vitae</router-link>
                                </a>
                                <a class="nav-item nav-link" href="javascript:void(0)">
                                    <router-link to="/skills" class="r-link"><i class="fas fa-user-astronaut" title="Skills"></i>Skills</router-link>
                                </a>
                                <a class="nav-item nav-link" href="javascript:void(0)">
                                    <router-link to="/reports" class="r-link"><i class="fas fa-user-graduate" title="Zeugnisse"></i>Zeugnisse</router-link>
                                </a>
                            </div>
                        </div>
                    </nav>
                </div>
                <div class="gb-brand"><i class="fas fa-crosshairs" title="gbuchholz"></i>| gbuchholz.de</div>
            </div>
        </header>

        <router-view @log-it="logIt($event)"/>

        <footer>
            <div class="gbuchholz">
                <router-link to="/" class="nav-bottom-item"><i class="fas fa-crosshairs" title="gbuchholz"></i>Home</router-link><br>
                <router-link to="/impressum" class="nav-bottom-item"><i class="fas fa-info-circle" title="Impressum"></i>Impressum</router-link><br>
                <router-link to="/kontakt" class="nav-bottom-item"><i class="fas fa-edit" title="Kontakt"></i>Kontakt</router-link>
            </div>
            <link
                href="https://fonts.googleapis.com/css?family=Play"
                rel="stylesheet">
            <link
                rel="stylesheet"
                href="https://use.fontawesome.com/releases/v5.1.0/css/all.css"
                integrity="sha384-lKuwvrZot6UHsBSfcMvOkWwlCMgc0TaWr+30HWe3a4ltaBwTZhyTEggF5tJv8tbt"
                crossorigin="anonymous">
        </footer>
    </div>
</template>

<script>
import siteConfig from '@/assets/js/mixins/siteConfig';
import JQuery from 'jquery';
let $ = JQuery;

export default {
    name: 'app',
    mixins: [
        siteConfig
    ],
    data() {
        return {
            doLog: window.location.href.search('localhost:') === -1
        };
    },
    methods: {
        /**
         * method for looging click event
         */
        logIt(logItem) {
            if (this.doLog) {
                $.ajax({
                    url: siteConfig.ajaxUrl + 'log.php',
                    type: 'POST',
                    data: 'logItem=' + logItem,
                    dataType: 'html'
                });
            }
        }
    },
    mounted() {
        $('.navbar-toggler').on('click', function() {
            $('#navbarNavAltMarkup').slideToggle('fast');
        });

        $('.nav-item').on('click', function() {
            $('#navbarNavAltMarkup').hide();
        });

        $('.nav-bottom-item').on('click', function() {
            $('#navbarNavAltMarkup').hide();
        });

        $(document).mouseup(function(e) {
            let nbvam = $('#navbarNavAltMarkup');
            if (!nbvam.is(e.target) &&
                nbvam.has(e.target).length === 0 &&
                !$('.navbar-toggler').is(e.target)
            ) {
                nbvam.slideUp('fast');
            }
        });
    }
};
</script>

<style lang="scss">
    html {
        height: 100%;
    }
    body {
        height: 100%;
        /* background: url('../img/gbuchholz_bg.png');
        background-repeat: no-repeat;
        background-attachment: fixed;
        background-position: 50% 70px; */
    }
    .wrapper {
        display: grid;
        grid-template-rows: auto 1fr auto;
        height: 100%;
    }
    header {
        margin-bottom: 25px;
        z-index: 1;
    }
    footer {
        margin-top: 60px;
    }
    .app {
        position: relative;
        max-width: 800px;
        margin: 0 auto;
        font-family: 'Play', 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;
        font-size: 1em;
        text-align: left;
        padding: 0;
        color: #000000;
    }
    a {
        color: #4682B4 !important;
    }
    .norification-error a:hover {
        color: #EEEEEE !important;
    }
    .nav {
        height: 45px;
        background: #555555;
    }
    .navbar {
        padding: 0 !important;
    }
    .navbar-nav {
        background: #555555;
        -webkit-border-radius: 0.25rem;
        -moz-border-radius: 0.25rem;
        border-radius: 0.25rem;
        line-height: 28px;
    }
    @media only screen and (max-width: 600px) {
        .navbar-nav {
            padding-bottom: 10px;
        }
    }
    .navbar-toggler {
        color: #AAAAAA !important;
        border: none !important;
    }
    .fa-bars {
        margin: 8px 0 5px 2px;
        a:active {
            border: none !important;
        }
    }
    .aix-menu {
        position: absolute;
        top: 0;
        left: 0;
    }
    .gb-brand {
        position: absolute;
        top: 9px;
        right: 12px;
        color: coral;
        font-size: 1.1em;
    }
    .nav-logo {
        text-align: right;
    }
    .nav-item {
        position: relative;
        height: 40px;
        font-size: 1.1em;
        padding-right: 10px;
        padding-left: 10px !important;
    }
    .nav-item-checkout {
        margin-top: 1px;
        margin-bottom: -1px;
    }
    .nav-item-enabled {
        display: none;
    }
    .nav-item-disabled {
        font-weight: bold;
        color: #2c3e50;
        opacity: 0.6;
    }
    .nav-bottom-item {
        color: #AAAAAA !important;
        margin: 0 25px 0 0;
    }
    .nav-item a:hover {
        color: #EEEEEE !important;
    }
    .nav-bottom-item:hover {
        color: #EEEEEE !important;
    }
    .gbuchholz {
        margin-top: 0;
        background: #555555;
        line-height: 1.8em;
        padding: 8px;

    }
    .divider {
        padding: 0 20px 0 10px;
    }
    .r-link {
        color: #AAAAAA !important;
    }
    .router-link-exact-active {
        color: #EEEEEE !important;
    }
    h1 {
        font-size: 1.5em !important;
        font-weight: bold !important;
    }
    h2 {
        font-size: 1.2em !important;
        font-weight: bold !important;
        margin-top: 30px !important;
    }
    h3 {
        font-size: 1.0em !important;
        font-weight: bold !important;
    }
    .content {
        padding: 0 10px;
    }
    .content-article {
        margin-top: 40px;
    }
    .row {
        margin: 0 !important;
    }
    .shop-step {
        float: left;
        width: 180px;
    }
    .clear-both {
        clear: both;
        width: 0;
        height: 0;
        font-size: 0;
        padding: 0;
        margin: 0;
    }
    .spacer {
        height: 100px;
    }
    hr {
        margin: 0 10px .5rem 10px !important;
    }
    .notification,
    .notification-shoppingcart,
    .notification-checkout {
        position: absolute;
        left: 0;
        bottom: 60px;
        max-width: 100%;
        padding: 10px;
        -webkit-border-radius: 0.25rem;
        -moz-border-radius: 0.25rem;
        border-radius: 0.25rem;
    }
    .notification-shoppingcart {
        bottom: 95px;
    }
    .notification-checkout {
        left: 0;
        bottom: 52px;
    }
    .notification-success {
        background: #228B22;
        color: #FFFFFF;
        border-left: 5px solid #556B2F;
        display: none;
    }
    .notification-hint {
        background: #FFA500;
        color: #000000;
        border-left: 5px solid #CC8C00;
        display: none;
    }
    .notification-error {
        background: #DC143C;
        color: #FFFFFF;
        border-left: 5px solid #aa0000;
        display: none;
    }
    .notification-warning {
        background: orange;
        color: #FFFFFF;
        border-left: 5px solid darkorange;
        display: none;
    }
    .notification-link {
        color: #EEEEEE !important;
        text-decoration: underline;
    }
    select {
        background: #FFFFFF;
    }
    .form-error {
        border-color: coral !important;
    }
    img {
        width: 100%;
        height: auto;
    }
    .fas,
    .far,
    .fab {
        width: 25px;
        text-align: center;
        margin-right: 4px;
    }
    .fa-crosshairs-aix {
        margin-right: 0;
    }
    .pos-rel {
        position: relative;
    }
    p {
        margin-bottom: 8px  !important;
    }
</style>
